export const scrollOnError = (selector = ".question-error") => {
    const questionError = document.querySelectorAll(selector);
    questionError[0].scrollIntoView({
        behavior: "smooth",
        block: "center",
    });
};
